import api from "apis/homeowner/caseEmail";
import { WebApiRequest, HTTP_POST, HTTP_GET, HTTP_PUT } from "tools/webservice";

export const sendCustomerEmail = (emailTransactionId, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.sendCustomerEmail(emailTransactionId),
  payload,
  successCallback,
  errorCallback,
  mountedRef
});

export const sendCustomerServiceEmail = (emailTransactionId, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.sendCustomerServiceEmail(emailTransactionId),
  payload,
  successCallback,
  errorCallback,
  mountedRef
});

export const getCustomerServiceEmail = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getCustomerServiceEmail(controlNumber),
  successCallback,
  mountedRef
});

export const startEmailTransaction = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.startEmailTransaction(),
  successCallback,
  mountedRef,
  payload: { controlNumber },
});

export const retrieveSettings = (emailTransactionId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.retrieveSettings(emailTransactionId),
  successCallback,
  mountedRef,
});

export const getEmailMessage = (emailTransactionId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.emailMessage(emailTransactionId),
  successCallback,
  mountedRef,
});

export const setEmailMessage = (emailTransactionId, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.emailMessage(emailTransactionId),
  successCallback,
  mountedRef,
  payload,
});

export const uploadAttachment = (emailTransactionId, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: api.uploadAttachment(emailTransactionId, payload.name, payload.type),
  successCallback,
  mountedRef,
  file: payload.uploadResult,
});

export const includeAttachment = (emailTransactionId, fileName, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: api.includeAttachment(emailTransactionId, fileName),
  successCallback,
  mountedRef,
});

export const sendEmail = (emailTransactionId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.sendEmail(emailTransactionId),
  successCallback,
  mountedRef,
});